import React, { Fragment } from "react";
import commonServices from "../../Utils/commonServices";
import useTranslation from "./../../customHooks/translations";

const CustomerProfile_emb = (props) => {
  const translation = useTranslation();
  // alert(props.customer?.name);
  return (
    <>
      <div style={{ backgroundColor: "lightgreen" }}>
        <div
          style={{
            width: "100%",
            textAlign: "center",
            fontWeight: "bold",
            color: "skyblue",
          }}
        >
          {translation.Customer_Information}
        </div>
        <Fragment>
          <div style={{ marginLeft: "115px" }}>
            <div style={{ width: "50px", float: "left" }}>
              <img
                style={{ width: "50px", height: "50px" }}
                className="mr-3 rounded-circle"
                src="./../../../public/images/avatar/avatar.png"
              />
            </div>
            <div style={{ width: "60%", float: "left", marginLeft: "30px" }}>
              <div style={{ width: "250px", float: "left" }}>
                <h5 className="m-b-3">{props.customer?.name}</h5>
              </div>
              <div style={{ width: "100px", float: "left" }}>
                <h5 className="m-b-3">{props.customer?.cellNo}</h5>
              </div>
              <div style={{ clear: "both" }}></div>

              <div style={{ width: "250px", float: "left" }}>
                <h5 className="m-b-3">
                  {commonServices.showDateRemovedT(
                    props.customer?.registeredDate
                  )}
                </h5>
              </div>
              <div style={{ width: "200px", float: "left" }}>
                <h5 className="m-b-3">{props.customer?.address}</h5>
              </div>
              <div style={{ width: "100px", float: "left" }}>
                <h5 className="m-b-3">{props.customer?.email}</h5>
              </div>
              <div style={{ width: "100px" }}>
                <h5 className="m-b-3">{props.customer?.alternetPhone}</h5>
              </div>
            </div>
            <div style={{ width: "50px", float: "right" }}>
              <span className="float-right">
                {/* {props.lstMeasurementDetail.length} */}{" "}
                <div className="btn-group m-b-20">
                  {props.mode === 3 && (
                    <>
                      <button
                        onClick={() => {
                          props.clearCustomerInfo();
                        }}
                        type="button"
                        className="btn btn-light"
                      >
                        ADD NEW
                      </button>
                      <button
                        onClick={() => {
                          props.changeMode(2);
                        }}
                        type="button"
                        className="btn btn-light"
                      >
                        <i className="fa fa-edit"> EDIT</i>
                      </button>
                    </>
                  )}
                  <button
                    // onClick={() => {
                    //   handleClickDelete(props.indexEntry);
                    // }}
                    type="button"
                    className="btn btn-light"
                  >
                    <i className="fa fa-trash"></i>
                  </button>
                </div>
              </span>
            </div>
            <div className="clearBoth"></div>
          </div>
        </Fragment>
      </div>
    </>
  );
};

export default CustomerProfile_emb;
